export const cTipoEdicionDTE = {
    NIT: 1,
    CUI: 2
}